import { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import {
    CheckOutlined, CloseOutlined, MinusOutlined, CopyOutlined, CheckCircleOutlined,
} from '@ant-design/icons';
import Toast from '../../helpers/Toast';
import formatDuration from '../../helpers/formatDuration';
import styles from './PipelineSteps.module.scss';

function StepIcon({ statut }) {
    if (statut === 'succes') return <span className={`${styles.icon} ${styles.iconSucces}`}><CheckOutlined /></span>;
    if (statut === 'echec') return <span className={`${styles.icon} ${styles.iconEchec}`}><CloseOutlined /></span>;
    if (statut === 'en_cours') return <span className={`${styles.icon} ${styles.iconEnCours}`} />;
    if (statut === 'ignore') return <span className={`${styles.icon} ${styles.iconIgnore}`}><MinusOutlined /></span>;
    return <span className={`${styles.icon} ${styles.iconAttente}`} />;
}
StepIcon.propTypes = { statut: PropTypes.string };

function Terminal({ output }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(output).then(() => {
            setCopied(true);
            Toast.success('Sortie copiée dans le presse-papiers.');
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className={styles.terminal}>
            <button className={styles.copyBtn} onClick={handleCopy} aria-label="Copier la sortie">
                <Tooltip title={copied ? 'Copié !' : 'Copier'}>
                    {copied ? <CheckCircleOutlined /> : <CopyOutlined />}
                </Tooltip>
            </button>
            <pre>{output}</pre>
        </div>
    );
}
Terminal.propTypes = { output: PropTypes.string.isRequired };

export default function PipelineSteps({ steps, compact = false }) {
    if (!steps || steps.length === 0) {
        return <div className={styles.empty}>En attente de démarrage…</div>;
    }

    return (
        <div className={`${styles.pipeline} ${compact ? styles.compact : ''}`}>
            {steps.map((step, i) => (
                <div key={`${step.label}-${i}`} className={`${styles.step} ${styles[`statut_${step.statut}`] ?? ''}`}>
                    <div className={styles.rail}>
                        <StepIcon statut={step.statut} />
                        {i < steps.length - 1 && <span className={styles.line} />}
                    </div>
                    <div className={styles.stepBody}>
                        <div className={styles.stepHeader}>
                            <span className={styles.stepLabel}>{step.label}</span>
                            {step.duration_ms != null && (
                                <span className={styles.stepDuration}>{formatDuration(step.duration_ms)}</span>
                            )}
                        </div>
                        {!compact && step.output_tail && <Terminal output={step.output_tail} />}
                    </div>
                </div>
            ))}
        </div>
    );
}

PipelineSteps.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        statut: PropTypes.string,
        duration_ms: PropTypes.number,
        output_tail: PropTypes.string,
    })),
    compact: PropTypes.bool,
};
